'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _saveItem = require('./remote/saveItem');

var SaveItem = {
    fetchSavedItemCounts: _saveItem.SaveItemRemote.fetchSavedItemCounts,
    postSaveItem: _saveItem.SaveItemRemote.postSaveItem,
    postUnsaveItem: _saveItem.SaveItemRemote.postUnsaveItem
};

exports.default = SaveItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/saveItem.js
// module id = wUUL
// module chunks = 60